(() => {
  const selectors = [
    '.bn-a2c-route__tiles a', '.bn-i2c-route__tiles a', '.bn-iso-route__tiles a',
    '.bn-camera-route__tiles a', '[data-frame-tiles] a', '[data-swi-tiles] a',
    '.bn-gp__tiles a', '.bn-integral__tiles a', '.bn-ca-route__tiles a', '.bn-mute-route__tiles a', '.bn-antenna__tiles a', '.bn-montage__tiles a', '.bn-usb__tiles a', '.bn-carkit__tiles a', '.bn-tomtom__tiles a', '.bn-pioneer__tiles a', '.bn-eiger__tiles a', '.bn-headsets__tiles a', '.bn-energy__tiles a'
  ].join(',');
  const cache = new Map();
  const collectionHandle = (anchor) => {
    try {
      const url = new URL(anchor.href, location.origin);
      const match = url.pathname.match(/^\/collections\/([^/]+)/);
      return match ? match[1] : '';
    } catch (_) { return ''; }
  };
  const firstImage = async (handle) => {
    if (!cache.has(handle)) cache.set(handle, fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=1`, { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : null)
      .then(data => data?.products?.[0]?.images?.[0]?.src || '')
      .catch(() => ''));
    return cache.get(handle);
  };
  const enhance = async (anchor) => {
    if (anchor.dataset.bnTileImageReady || anchor.querySelector('img')) return;
    anchor.dataset.bnTileImageReady = 'loading';
    const handle = collectionHandle(anchor);
    if (!handle) return;
    const src = await firstImage(handle);
    if (!src || !anchor.isConnected) return;
    const label = anchor.querySelector('strong')?.textContent?.trim() || 'Productcategorie';
    const img = document.createElement('img');
    img.className = 'bn-auto-tile-image'; img.src = src; img.alt = label; img.loading = 'lazy'; img.width = 184; img.height = 216;
    const copy = document.createElement('span'); copy.className = 'bn-auto-tile-copy';
    [...anchor.childNodes].forEach(node => copy.appendChild(node));
    anchor.append(img, copy); anchor.classList.add('bn-auto-image-tile'); anchor.dataset.bnTileImageReady = 'true';
  };
  const scan = (scope = document) => scope.querySelectorAll(selectors).forEach(enhance);
  const style = document.createElement('style');
  style.textContent = `${selectors}{overflow:hidden}.bn-auto-image-tile{display:grid!important;grid-template-columns:92px minmax(0,1fr)!important;padding:0!important;gap:0!important;align-items:stretch!important}.bn-auto-tile-image{width:92px!important;height:100%!important;min-height:108px!important;object-fit:contain!important;background:#fff!important;padding:7px!important;box-sizing:border-box!important;border-right:1px solid #cbd7e6}.bn-auto-tile-copy{display:flex;min-width:0;flex-direction:column;justify-content:center;gap:8px;padding:16px}.bn-auto-tile-copy>strong,.bn-auto-tile-copy>span{display:block}`;
  document.head.appendChild(style);
  scan();
  document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  new MutationObserver(records => records.forEach(r => r.addedNodes.forEach(n => { if (n.nodeType === 1) { if (n.matches?.(selectors)) enhance(n); scan(n); } })))
    .observe(document.documentElement, { childList: true, subtree: true });
})();
